<template>
  <div class="card mb-4">
    <TableInfoBar
      :total="totalItems"
      v-model:pageSize="pageSize"
      :page-sizes="pageSizes"
      create-label="재료정보 등록"
      v-model:query="q"
      :searchPlaceholder="'이름/URN 검색'"
      @search="onSearch"
      @create="createData"
    />

    <div class="card-body px-4 pt-0 pb-2">
      <BaseDataTable
        :loading="loading"
        :items="rawMaterialList"
        :columns="columns"
        :total="totalItems"
        v-model:page="page"
        v-model:pageSize="pageSize"
        :page-sizes="pageSizes"
        :colgroup="colgroup"
        :rowKey="rowKey"
        empty-message="등록된 재료가 없습니다."
        @row-click="onRowClick"
      >
        <template #row="{ item, index }">
          <td class="text-center text-sm">{{ totalItems - rowStartIndex - index }}</td>
          <td class="text-center text-sm">{{ item.name }}</td>
          <td class="text-center text-sm">
            <CustomBadge level="very-high" size="sm" :label="item.urn" />
          </td>
          <td class="text-center text-sm">{{ formatDate(item.createdAt) }}</td>
          <td class="text-center text-sm">{{ item.updatedAt ? formatDate(item.updatedAt) : '-' }}</td>
        </template>
      </BaseDataTable>
    </div>
  </div>

  <RawMaterialTour />
</template>

<script>
import CustomBadge from '@/components/CustomBadge.vue';
import BaseDataTable from '@/components/BaseDataTable.vue';
import TableInfoBar from '@/components/pagination/TableInfoBar.vue';
import SoftButton from "@/components/SoftButton.vue";
import RawMaterialTour from "@/components/tour/RawMaterialTour.vue";
import api from '@/api/api';

export default {
  name: "raw-material-table",
  components: { CustomBadge, SoftButton, BaseDataTable, TableInfoBar, RawMaterialTour },
  data() {
    return {
      loading: false,
      rawMaterialList: [],
      categoryList: [],
      page: 1,
      pageSize: 10,
      pageSizes: [10, 20, 50],
      totalItems: 0,
      sort: 'createdAt',
      columns: [
        { label: 'No.' },
        { label: '이름' },
        { label: 'urn' },
        { label: '생성일시' },
        { label: '수정일시' },
      ],
      colgroup: [
        'width:10%',
        'width:25%',
        'width:25%',
        'width:20%',
        'width:20%',
      ],
      q: "",
    };
  },
  computed: {
    rowStartIndex() {
      return (this.page - 1) * this.pageSize;
    },
  },
  watch: {
    page() {
      this.fetchData();
    },
    pageSize() {
      this.fetchData();
    },
  },
  mounted() { 
    const { page, size, q, sort } = this.$route.query;
    this.updatingFromRoute = true;  
    if (page) this.page = +page;
    if (size) this.pageSize = +size;
    if (q !== undefined) this.q = q;
    if (sort) this.sort = sort;
    this.updatingFromRoute = false;
    this.fetchData(); 
  },
  methods: {
    rowKey(item, idx) { return item.id ?? idx; },
    async fetchData() {
      if(this.loading) return;

      this.loading = true;
      try {
        const mfId = this.$store.getters['UserStore/getMfId'];
        const [res] = await Promise.all([
          api.get('/rawMaterial/page', {
            params: { mfId, page: this.page, size: this.pageSize, sort: this.sort, query: this.q  }
          }),
          new Promise(r => setTimeout(r, 600))
        ]);

        const r = res.data?.result || {};
        this.rawMaterialList = r.items || [];
        this.totalItems = Number(r.total || 0);

        const pageCount = Math.max(1, Math.ceil(this.totalItems / this.pageSize));
        if (this.page > pageCount) this.page = pageCount;
      } catch (error) {
        console.error("재료 목록 불러오기 실패:", error);
      } finally {
        this.loading = false;
      }
    },
    onSearch() {
      this.page = 1;
      this.fetchData();
    },
    onRowClick(item, index){
      this.$router.push({
        name: "RawMaterialEdit",
        params: { id: item.id },
        query: {
          page: this.page,
          size: this.pageSize,
          q: this.q,
          sort: this.sort,
        },
      });
    },
    createData(){
      this.$router.push({
        name: "RawMaterialCreate",
      });
    }
  }
};
</script>
